import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
  Tabs,
} from "InnoUI/components";
import SC from "./style";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { apiGet } from "api/callApi";
import TooltipText from "components/TooltipText";
import theme, { getBorderColor } from "@theme";
import { requestType, requestTypeForUpdate } from "utils/optionData/utils";
import debounce from "lodash.debounce";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import EmailDetailsTooltip from "components/EmailDetailsTooltip";
import TimezoneConverter from "components/TimeZoneConvertor";
import JournalDetails from "../JournalDetails";
import InnoIcons from "@InnoIcons/";
import { formatAlarmDateTime } from "utils/helper";

const OpenThread = (props) => {
  const { popupState } = props;
  const [data, setData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const journalId = searchParams.get("journalId");
  const closeJounal = searchParams.get("closeJounal");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const getJournalData = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet(`/v1/journal/threads/${journalId}`, false);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getJournalData();
  }, [journalId]);

  const onRowClick = useCallback(() => {}, []);

  const handleUpdate = (record) => {
    navigate(
      `/journal/update-journal?projectId=${projectId}&folderId=${folderId}&type=${type}&journalId=${record.id}`
    );
  };

  const handleJournalClick = (record) => {
    setSelectedRow(record.id);
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const journalColumn = [
    {
      title: "S.No.",
      width: 10,
      // onCell: (record) => ({
      //   style: {
      //     borderLeft: getBorderColor(record.requestType),
      //   },
      // }),
      render(value, record, index) {
        return <p>{index + 1}</p>;
      },
    },
    {
      title: "Journal Subject",
      width: 320,
      dataIndex: "subject",

      render(value, record) {
        const menuItems = [
          {
            id: 2,
            text: "Update",
            onClick: () => handleUpdate(record),
          },
        ];
        return (
          <SC.PopoverContainer>
            <TooltipText title={value} maxLength={0} />
            {/* <SC.PopoverSpan>
              <Popover
                sx={{
                  cursor: "pointer",
                }}
                buttonLabel={{
                  icon: <SC.MoreVertIcon />,
                }}
                popoverContent={
                  <TableList
                    sx={{
                      borderBottom: `1px solid ${theme.colors.bordertask}`,
                    }}
                    items={menuItems || []}
                    popupState={popupState}
                  />
                }
              />
            </SC.PopoverSpan> */}
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Request Type",
      width: 150,
      dataIndex: "requestType",
      render(value, record) {
        const request = requestTypeForUpdate.find((item) => item.id === value);
        return <p>{request ? request.label : "Unknown"}</p>;
      },
    },
    {
      title: "Request To",
      width: 200,
      dataIndex: "roles",
      render(value, record) {
        const roleNames = record?.roles.map((role) => role.roleName).join(", ");
        return value ? (
          <Popover
            sx={{
              cursor: "pointer",
            }}
            buttonLabel={{
              icon: <SC.ParagaphStyle>{roleNames}</SC.ParagaphStyle>,
            }}
            popoverContent={
              <SC.Table>
                <SC.Thead>
                  <SC.TR>
                    <SC.Th>Roles</SC.Th>
                  </SC.TR>
                </SC.Thead>
                <SC.Tbody>
                  <SC.Tr>
                    <SC.Td>{roleNames || "N/A"}</SC.Td>
                  </SC.Tr>
                </SC.Tbody>
              </SC.Table>
            }
          />
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "To",
      width: 200,
      dataIndex: "sendTo",
      render(value, record) {
        return <EmailDetailsTooltip data={record?.sendToWithName} />;
      },
    },
    {
      title: "Created By",
      width: 150,
      dataIndex: "createdByName",
      render(value, record) {
        return <p>{value}</p>;
      },
    },

    {
      title: "Created Date & Time",
      width: 210,

      dataIndex: "createdOn",
      render(value, record) {
        return (
          <p>
            <TimezoneConverter time={value} />
          </p>
        );
      },
    },
    {
      title: "Alarm set for",
      width: 210,
      render(value, record) {
        const alarmData = record?.alarm || [];
        const primaryAlarms = alarmData.filter(
          (alarm) => alarm.alarmType === 0
        );
        if (!primaryAlarms.length) return <p>-</p>;
        const { alarmDate, alarmTime } = primaryAlarms[0];
        return <p>{formatAlarmDateTime(alarmDate, alarmTime)}</p>;
      },
    },
  ];

  if (type == 0) {
    journalColumn.splice(4, 0, {
      title: "Occupant Name",
      width: 150,
      dataIndex: "propertyName",
      render(value, record) {
        return <p>{value}</p>;
      },
    });
  }

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: false,
    search: false,
    action: false,
    divBorder: false,
    sno: false,
    addDummyData: false,
    pagination: false,
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      <CustomBreadcrumb />
      {/* <div
        style={{
          margin: "50px 0px 0px 0px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 25px 0px 0px",
        }}
      >
        <SC.TabDiv>
          <SC.HeaderContainer>
            <SC.HeaderStyle>Journal</SC.HeaderStyle>
            <SC.CountStyle>({record?.totalCount})</SC.CountStyle>
          </SC.HeaderContainer>

          <SC.InputContiner>
            <SC.SearchIcon />
            <SC.InputStyle
              placeholder="Search journal"
              onChange={handleSearch}
            />
          </SC.InputContiner>
        </SC.TabDiv>

      </div> */}
      <div
        style={{
          margin: "50px 0px 20px 0px",
          //   margin: "0 0 20px 0",
          borderBottom: `1px solid ${theme.colors.bordertask}`,
          padding: "0 0 0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: "10px",
          }}
        >
          <InnoIcons.ArrowBackIcon
            sx={{
              cursor: "pointer",
              fontSize: "20px",
              marginRight: "5px",
            }}
            onClick={() => handleBackClick()}
          />
          <span style={{ fontWeight: "bold", fontSize: "15px" }}>
            {"Journal Thread"}
          </span>
        </div>
        {/* <SC.RICContainer>
          {["Request", "Include in report", "Comments"].map((text, index) => (
            <SC.Paragraph key={index}>
              {index === 0 && <SC.Rspan />}
              {index === 1 && <SC.Ispan />}
              {index === 2 && <SC.Cspan />}
              {text}
            </SC.Paragraph>
          ))}
        </SC.RICContainer> */}
      </div>

      <div>
        <InnoTable
          tableConfig={tableConfig}
          padding={"4px 8px 6px 8px"}
          column={journalColumn}
          data={data}
          onRowClickCallback={onRowClick}
          tableKey={"Journal"}
          loading={isLoading}
          searchKeys={["propertyName", "displayTemplateName"]}
          // borderleft="none"
          onRow={(record) => ({
            onClick: (event) => {
              setTimeout(() => {
                if (!document.querySelector(".ant-image-preview-mask")) {
                  handleJournalClick(record);
                }
              }, 100);
            },
          })}
        />
      </div>

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          closable={true}
          width={"970px"}
          children={
            <JournalDetails
              onClose={closeDrawer}
              selectedRowId={selectedRow}
              fetchData={getJournalData}
            />
          }
        ></DetailDrawer>
      )}
    </>
  );
};

export default OpenThread;
